import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { compose, Query, graphql } from 'react-apollo';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import {
  Grid,
  Row,
  Col,
  Table,
  Tooltip,
  OverlayTrigger,
  Button,
  Modal,
  FormGroup,
  FormControl,
  Label,
  NavDropdown,
  NavItem,
} from 'react-bootstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import CardTable from 'components/CardTable/CardTable.jsx';
import { Layout, ModalConfirm } from '../../components';
import { UploadFile } from './container';
import classesLazada from '../../Lazada.module.css';
import s3 from 'config/s3';
import reportUrl from 'config/reportUrl';
import lambdaUrl from 'config/lambdaUrl';
import adminListQuery from './graphql/query/adminList';
import { client } from '../../../../index';
import lazadaImportOrderListQuery from './graphql/query/lazadaImportOrderList';
import lazadaImportOrderUpdateMutation from './graphql/mutation/lazadaImportOrderUpdate';
import updateTrackingBySummaryMutation from './graphql/mutation/updateTrackingBySummary';
import customerId from 'config/customerId';

const NavDropdownContainer = styled(NavDropdown)`
  list-style: none;
  float: left;
  margin-left: 5px;

  & a {
    & .caret {
      display: none;
    }

    & button.btn.btn-default {
      float: left;
      padding: 5px 8px;
    }
  }
`;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  float: right;

  & .text {
    padding: 5px;
  }
  & .form-control {
    padding: 6px 10px;
    height: 30px;
    width: 70px;
  }
`;

const NavItemDropDownList = styled(NavItem)``;

const NavItemA = styled.li`
  & a {
    padding: 8px 16px;
    color: #333333;
    display: block;
    clear: both;
    font-weight: 400;
    line-height: 1;
    white-space: nowrap;
  }
`;

class Shipments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      fileStatus: 0,
      createDate: '',
      displayCreateDate: '',
      pickupDate: '',
      displayPickupDate: '',
      transferDate: '',
      displayTransferDate: '',
      pageNumber: 1,
      isOpenModalConfirmCancel: false,
      isOpenModalConfirmDownloadReport: false,
      lazadaReportOption: null,
      bookingNumber: '',

      // select file cancel
      fileNameBookingFile: '',
      idBookingFile: null,
      isLoading: false,
      showImportModal: false,
      importFile: null,
      importDate: '',
      show_importDate: '',
      lazada_order_type_in: null,
    };
    this._inputImportFile = React.createRef();
    this._inputImportFile1 = React.createRef();
  }
  uploadFileHandler = async file => {
    try {
      await this.props
        .updateTrackingBySummaryMutation({
          variables: {
            path: file.path,
          },
          refetchQueries: ['lazadaImportOrderListQuery'],
        })
        .then(({ data }) => {
          if (data.updateTrackingBySummary.succeed) {
            this.setState({
              showImportModal: false,
              importFile: null,
              importDate: '',
              show_importDate: '',
            });
          }
        });
    } catch (error) {
      this.setState({
        showImportModal: false,
        importFile: null,
        importDate: '',
        show_importDate: '',
      });

      alert(error);
    }
  };

  renderStatus = status => {
    switch (status) {
      case 4:
        return <Label bsStyle="primary">รอเริ่มงาน</Label>;
      case 5:
        return (
          <Label
            bsStyle="info"
            style={{
              backgroundColor: 'transparent',
              color: '#337ab7',
              border: '1px solid #337ab7',
            }}
          >
            กำลังดำเนินงาน...
          </Label>
        );
      case 6:
        return <Label bsStyle="success">เสร็จสิ้นแล้ว</Label>;
      case 7:
        return (
          <Label
            bsStyle="success"
            style={{
              backgroundColor: 'transparent',
              color: '#5cb85c',
              border: '1px solid #5cb85c',
            }}
          >
            ส่ง Report แล้ว
          </Label>
        );
      case 8:
        return <Label bsStyle="success">โอนเงิน Lazada แล้ว</Label>;
      case 9:
        return <Label bsStyle="danger">ยกเลิก</Label>;
      default:
        return <Label>{status}</Label>;
    }
  };

  handleDateRangePicker = (mode, picker) => {
    const date = `${picker.startDate.format('YYYY-MM-DD')}:${picker.endDate.format('YYYY-MM-DD')}`;

    const display = `${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format(
      'DD/MM/YYYY'
    )}`;

    if (mode === 'createDate') {
      this.setState({ createDate: date, displayCreateDate: display });
    } else if (mode === 'pickupDate') {
      this.setState({ pickupDate: date, displayPickupDate: display });
    } else if (mode === 'transferDate') {
      this.setState({ transferDate: date, displayTransferDate: display });
    }
  };

  cancelShipmentLazada = async () => {
    try {
      this.setState({ isLoading: true });

      const { idBookingFile } = this.state;
      const { data } = await client.query({
        query: lazadaImportOrderListQuery,
        variables: {
          _id: idBookingFile,
        },
      });

      const { order } = data.lazadaImportOrderList;

      if (order[0].status !== 4) {
        alert('ไม่สามารถยกเลิกรายการได้');
        this.setState({ isLoading: false });
        return;
      }

      await this.props
        .lazadaImportOrderUpdateMutation({
          variables: {
            _id: idBookingFile,
            status: 9,
          },
          refetchQueries: ['LazadaImportOrderListShipments'],
        })
        .then(({ data }) => {
          if (data.lazadaImportOrderUpdate._id) {
            this.setState({
              isLoading: false,
              isOpenModalConfirmCancel: false,
            });
          }
        });
    } catch (error) {
      this.setState({
        isLoading: false,
        isOpenModalConfirmCancel: false,
      });

      alert(error);
    }
  };

  callExportReport = (content, url) => {
    try {
      let headers = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const result = axios
        .post(lambdaUrl + url, content, headers)
        .then(results => {
          console.log(results);
        })
        .catch(err => {
          console.log(err);
        });
      setTimeout(() => {
        window.location = '/downloadreport';
      }, 500);
    } catch (error) {
      console.log(error);
    }
  };

  downloadReportHandler = async () => {
    try {
      const { data } = await client.query({
        query: adminListQuery,
      });

      const { admin } = data.adminList;

      if (admin.length === 0) {
        alert('ไม่พบ Admin');
        return;
      }

      const { idBookingFile } = this.state;
      const adminId = admin[0]._id;
      this.callExportReport(
        JSON.stringify({
          pick_up_date: this.state.reportDate,
          admin_id: adminId,
          shipper: customerId.lazada,
        }),
        '/ka-summary-report'
      );
      if (this.state.lazadaReportOption) {
        this.callExportReport(
          JSON.stringify({
            pick_up_date: this.state.reportDate,
            admin_id: adminId,
            shipper: customerId.lazada,
            lazada_order_type: this.state.lazadaReportOption,
          }),
          '/ka-summary-report'
        );
      }
    } catch (error) {
      alert(error);
    }
  };

  downloadReportByIdHandler = async () => {
    try {
      const { data } = await client.query({
        query: adminListQuery,
      });

      const { admin } = data.adminList;

      if (admin.length === 0) {
        alert('ไม่พบ Admin');
        return;
      }

      const { idBookingFile } = this.state;
      const adminId = admin[0]._id;
      this.callExportReport(
        JSON.stringify({
          admin_id: adminId,
          _id: idBookingFile,
        }),
        '/ka-summary-report'
      );
      this.setState({
        isOpenModalConfirmDownloadIdReport: false,
      });
    } catch (error) {
      alert(error);
    }
  };

  downloadPickupReportByIdHandler = async () => {
    try {
      const { data } = await client.query({
        query: adminListQuery,
      });

      const { admin } = data.adminList;

      if (admin.length === 0) {
        alert('ไม่พบ Admin');
        return;
      }

      const { idBookingFile } = this.state;
      const adminId = admin[0]._id;

      const body = JSON.stringify({
        import_order_id: idBookingFile,
        admin_id: adminId,
      });

      const configs = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const url = '/lazada-pickup-report';
      const result = axios
        .post(lambdaUrl + url, body, configs)
        .then(res => {
          console.log(res);
        })
        .catch(error => {
          console.log(error);
        });
      setTimeout(() => {
        window.location = '/downloadreport';
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  formatMoney = number => {
    return `฿ ${number.toLocaleString('en-US', {
      maximumFractionDigits: 2,
    })}`;
  };

  openReportShipment(mode) {
    this.setState({
      isOpenModalConfirmDownloadReport: true,
      modeReport: mode,
      reportDate: '',
      show_reportDate: '',
      lazadaReportOption: null,
    });
  }

  handleDateRangePickerReport(event, picker) {
    const date = `${picker.startDate.format('YYYY-MM-DD')}:${picker.endDate.format('YYYY-MM-DD')}`;
    const show = `${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format(
      'DD/MM/YYYY'
    )}`;
    this.setState({ reportDate: date, show_reportDate: show });
  }

  renderStatusMode = status => {
    switch (status) {
      case 0:
        return <span class="label label-success">Trip LOY</span>;
      case 1:
        return <span class="label label-success">Last Mile (LM)</span>;
      case 2:
        return <span class="label label-danger">Return to Merchant (RM)</span>;
      case 3:
        return (
          <span class="label" style={{ backgroundColor: '#318DE8' }}>
            FIRST MILE (FM) (Import)
          </span>
        );
      case 4:
        return (
          <span class="label" style={{ backgroundColor: '#FFDB46', color: 'black' }}>
            SPECIAL (SP)
          </span>
        );
      case 5:
        return (
          <span class="label" style={{ backgroundColor: '#ff9800' }}>
            Return (RT)
          </span>
        );
      case 6:
        return (
          <span class="label" style={{ backgroundColor: '#82c5b9' }}>
            Return to WH (RTWH)
          </span>
        );
      case 7:
        return (
          <span class="label" style={{ backgroundColor: '#82c5f9' }}>
            Return to Customer (CR/RC)
          </span>
        );
      case 8:
        return (
          <span class="label" style={{ backgroundColor: '#FF0505' }}>
            Return to Merchant (CR/RM)
          </span>
        );
      case 9:
        return (
          <span class="label" style={{ backgroundColor: '#d6949e' }}>
            First Mile (FM)
          </span>
        );
      case 10:
        return (
          <span class="label" style={{ backgroundColor: '#bcddfd', color: '#318de8' }}>
            Shuttle Haul (SH)
          </span>
        );
      case 11:
        return (
          <span class="label" style={{ backgroundColor: '#ffe2bb', color: '#e28200' }}>
            Reject Return (RR)
          </span>
        );
      case 12:
        return (
          <span class="label" style={{ backgroundColor: '#d9e2ff', color: '#318DE8' }}>
            Direct Ship (DS)
          </span>
        );
      case 13:
        return (
          <span class="label" style={{ backgroundColor: '#FFDB46', color: 'black' }}>
            Line Haul (LH)
          </span>
        );
      case 14:
        return (
          <span class="label" style={{ backgroundColor: '#9933ff', color: '#FFFFFF' }}>
            BU First Mile (BUFM)
          </span>
        );
      default:
        return status;
    }
  };

  render() {
    let admin = '';
    let admin_id = '';
    if (this.props.adminName.loading == false && this.props.adminName.adminList != undefined) {
      admin = this.props.adminName.adminList.admin[0].admin_username;
      admin_id = this.props.adminName.adminList.admin[0]._id;
    }
    return (
      <Layout>
        <Row>
          <Col md={12}>
            <div>
              <Query
                query={lazadaImportOrderListQuery}
                variables={{
                  name: this.state.fileName,
                  format_bookname: this.state.bookingNumber,
                  status: this.state.fileStatus,
                  pick_up_date: this.state.pickupDate,
                  create_date: this.state.createDate,
                  transfer_date: this.state.transferDate,
                  create_shipment: 2,
                  page_number: this.state.pageNumber,
                  account_info_id: customerId.lazada,
                  import_order_type: this.state.lazada_order_type_in,
                }}
                fetchPolicy="cache-and-network"
              >
                {({ data, loading, error, refetch: refetchLazadaImportOrderList }) => {
                  //console.log("lazadaImportOrderListQuery",data)
                  var itemLength = 'loading';
                  const itemIndicatorSize = (this.state.pageNumber - 1) * 30;
                  if (data.lazadaImportOrderList) {
                    if (data.lazadaImportOrderList.order.length > 0) {
                      itemLength = data.lazadaImportOrderList.order.length;
                    }
                  }
                  return (
                    <CardTable
                      title="ตาราง Booking file"
                      category="*ต้อง Import file booking ที่ แถบ Booking file ก่อน สร้าง Shipment ทุกครั้ง"
                      ctTableFullWidth
                      ctTableResponsive
                      rightButton={
                        <div style={{ float: 'right', marginLeft: '15px' }}>
                          {
                            // <Button
                            //   style={{ background: '#87CB16', color: '#ffffff', marginRight: '15px' }}
                            //   onClick={() => {
                            //     this.setState({
                            //       showImportModal: true,
                            //       importFile: null,
                            //       importDate: '',
                            //       show_importDate: '',
                            //     });
                            //   }}
                            // >
                            //   <i className="fas fa-cloud-upload"></i> อัพโหลด Tracking
                            // </Button>
                          }
                          <Button
                            style={{ marginLeft: '15px' }}
                            onClick={() => this.openReportShipment('booking')}
                          >
                            {' '}
                            <i className="fal fa-clipboard-list"></i> รายงานงานขนส่ง{' '}
                          </Button>
                        </div>
                      }
                      content={
                        <div>
                          <PageWrapper style={{ textAlign: 'right' }}>
                            <div className="text">
                              {this.state.pageNumber === 1
                                ? `1 - ${itemLength}`
                                : `${itemIndicatorSize + 1} - ${itemLength +
                                    itemIndicatorSize}`}{' '}
                              หน้า :
                            </div>
                            <FormControl
                              type="number"
                              min={1}
                              value={this.state.pageNumber}
                              onChange={event =>
                                Number(event.target.value) >= 0
                                  ? setInterval(
                                      this.setState({
                                        pageNumber: Number(event.target.value),
                                      }),
                                      1000
                                    )
                                  : setInterval(this.setState({ pageNumber: 1 }), 1000)
                              }
                              name="page_number"
                            />
                            <div className="text">
                              {' '}
                              {loading || error
                                ? ''
                                : `จาก ${data.lazadaImportOrderList.total_page}`}
                            </div>
                          </PageWrapper>
                          <div className="table-vertical">
                            <Table striped hover>
                              <thead>
                                <tr>
                                  <th style={{ minWidth: '140px' }}>เครื่องมือ</th>
                                  <th style={{ minWidth: '140px' }}>mode</th>
                                  <th style={{ minWidth: '200px' }}>Booking Number</th>
                                  <th style={{ minWidth: '200px' }}>ชื่อไฟล์</th>
                                  <th style={{ minWidth: '100px' }}>วันที่รับสินค้า</th>
                                  <th style={{ minWidth: '140px' }}>สถานะ</th>
                                  <th style={{ minWidth: '120px' }}>จำนวน Trip</th>
                                  <th style={{ minWidth: '100px' }}>COD รับแล้ว</th>
                                  {
                                    // <th style={{ minWidth: '130px' }}>COD ยังไม่ได้รับ</th>
                                    // <th style={{ minWidth: '100px' }}>COD ทั้งหมด</th>
                                  }
                                  <th style={{ minWidth: '100px' }}>COD ยกเลิก</th>
                                  <th style={{ minWidth: '120px' }}>3PL Confirm COD</th>
                                  {
                                    // <th style={{ minWidth: '120px' }}>วันที่โอนเงิน</th>
                                  }
                                  <th style={{ minWidth: '120px' }}>วันที่ Import file</th>
                                </tr>
                                <tr>
                                  <th></th>
                                  <th>
                                    <FormControl
                                      componentClass="select"
                                      placeholder="select"
                                      defaultValue={0}
                                      value={this.state.lazada_order_type_in}
                                      onChange={event => {
                                        if (event.target.value == 0) {
                                          this.setState({
                                            lazada_order_type_in: null,
                                          });
                                        } else {
                                          this.setState({
                                            lazada_order_type_in: Number(event.target.value),
                                          });
                                        }
                                      }}
                                      name="order_type"
                                    >
                                      <option value={0}>ทั้งหมด</option>
                                      <option value={1}>Last Mile (LM)</option>
                                      <option value={2}>Return to Merchant (RM)</option>
                                      <option value={5}>Return (RT)</option>
                                      <option value={9}>First Mile (FM)</option>
                                      <option value={10}>Shuttle Haul (SH)</option>
                                      <option value={11}>Reject Return (RR)</option>
                                      <option value={12}>Direct Ship (DS)</option>
                                      <option value={13}>Line Haul (LH)</option>
                                      <option value={14}>BU First Mile (BUFM)</option>
                                    </FormControl>
                                  </th>
                                  <th>
                                    <FormControl
                                      type="text"
                                      placeholder="ค้นหาBooking Number"
                                      name="bookingNumber"
                                      value={this.state.bookingNumber}
                                      onChange={event => {
                                        this.setState({
                                          bookingNumber: event.target.value,
                                          pageNumber: 1,
                                        });
                                      }}
                                    />
                                  </th>
                                  <th>
                                    <FormControl
                                      type="text"
                                      placeholder="ค้นหาชื่อไฟล์"
                                      name="file_name"
                                      value={this.state.fileName}
                                      onChange={event => {
                                        this.setState({
                                          fileName: event.target.value,
                                          pageNumber: 1,
                                        });
                                      }}
                                    />
                                  </th>
                                  <th>
                                    <DateRangePicker
                                      onApply={(event, picker) =>
                                        this.handleDateRangePicker('pickupDate', picker)
                                      }
                                      onCancel={() =>
                                        this.setState({
                                          pickupDate: '',
                                          displayPickupDate: '',
                                          pageNumber: 1,
                                        })
                                      }
                                      containerStyles={{ display: 'block' }}
                                      opens="right"
                                      format="DD/MM/YYYY"
                                    >
                                      <FormControl
                                        type="text"
                                        value={this.state.displayPickupDate}
                                        placeholder="วันที่รับสินค้า"
                                      />
                                    </DateRangePicker>
                                  </th>
                                  <th>
                                    <FormControl
                                      componentClass="select"
                                      placeholder="select"
                                      defaultValue={this.state.fileStatus}
                                      onChange={event =>
                                        this.setState({
                                          fileStatus: event.target.value,
                                          pageNumber: 1,
                                        })
                                      }
                                      name="shipment_status"
                                    >
                                      <option value={0}>ทั้งหมด</option>
                                      <option value={4}>รอเริ่มงาน</option>
                                      <option value={5}>กำลังดำเนินงาน...</option>
                                      <option value={6}>ขนส่งเสร็จสิ้น</option>
                                      <option value={7}>ส่ง Report แล้ว</option>
                                      <option value={8}>โอนเงิน Lazada แล้ว</option>
                                      <option value={9}>ยกเลิก</option>
                                    </FormControl>
                                  </th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  {
                                    // <th></th>
                                    // <th></th>
                                  }
                                  <th></th>
                                  {
                                    // <th>
                                    //   <DateRangePicker
                                    //     onApply={(event, picker) =>
                                    //       this.handleDateRangePicker('transferDate', picker)
                                    //     }
                                    //     onCancel={() =>
                                    //       this.setState({
                                    //         transferDate: '',
                                    //         displayTransferDate: '',
                                    //         pageNumber: 1,
                                    //       })
                                    //     }
                                    //     containerStyles={{ display: 'block' }}
                                    //     opens="right"
                                    //     format="DD/MM/YYYY"
                                    //   >
                                    //     <FormControl
                                    //       type="text"
                                    //       value={this.state.displayTransferDate}
                                    //       placeholder="วันที่โอนเงิน"
                                    //     />
                                    //   </DateRangePicker>
                                    // </th>
                                  }
                                  <th>
                                    <DateRangePicker
                                      onApply={(event, picker) =>
                                        this.handleDateRangePicker('createDate', picker)
                                      }
                                      onCancel={() =>
                                        this.setState({
                                          createDate: '',
                                          displayCreateDate: '',
                                          pageNumber: 1,
                                        })
                                      }
                                      containerStyles={{ display: 'block' }}
                                      opens="right"
                                      format="DD/MM/YYYY"
                                    >
                                      <FormControl
                                        type="text"
                                        value={this.state.displayCreateDate}
                                        placeholder="วันที่ Import file"
                                      />
                                    </DateRangePicker>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading && (
                                  <tr>
                                    <td colSpan="12">Loading...</td>
                                  </tr>
                                )}

                                {error && (
                                  <tr>
                                    <td colSpan="12">Error</td>
                                  </tr>
                                )}

                                {!loading &&
                                  !error &&
                                  data.lazadaImportOrderList.order.length === 0 && (
                                    <tr>
                                      <td colSpan="12">ไม่มีข้อมูล</td>
                                    </tr>
                                  )}

                                {!loading &&
                                  !error &&
                                  data.lazadaImportOrderList.order.length > 0 &&
                                  data.lazadaImportOrderList.order.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={<Tooltip id="tooltip">ดูข้อมูล</Tooltip>}
                                        >
                                          <Link
                                            to={`/ka-shipment-list-new?id=${item._id}`}
                                            style={{ float: 'left' }}
                                            className="btn btn-default"
                                          >
                                            <i
                                              style={{ marginTop: '3px' }}
                                              className="fas fa-eye"
                                            ></i>
                                          </Link>
                                        </OverlayTrigger>
                                        <NavDropdownContainer
                                          title={
                                            <Button>
                                              เครื่องมือ <i className="fal fa-angle-down"></i>
                                            </Button>
                                          }
                                        >
                                          {/* <NavItemDropDownList disabled>
                                            <i className="fas fa-bell"></i> แจ้งโอนเงินให้ LAZADA
                                          </NavItemDropDownList> */}

                                          <NavItemDropDownList
                                            onClick={() => {
                                              this.setState({
                                                isOpenModalConfirmDownloadIdReport: true,
                                                fileNameBookingFile: item.name,
                                                idBookingFile: item._id,
                                              });
                                            }}
                                          >
                                            <i className="fas fa-file-alt"></i> รายงานงานขนส่ง
                                          </NavItemDropDownList>

                                          <NavItemDropDownList
                                            onClick={() => {
                                              const url = `${reportUrl}/v2/getPriceLazadaReport?file_id=${item._id}`;
                                              window.open(url, '_blank');
                                            }}
                                          >
                                            <i className="fas fa-file-alt"></i> รายงานราคา v2
                                          </NavItemDropDownList>

                                          {(item.order_type == 3 || item.order_type == 5) && (
                                            <NavItemDropDownList
                                              onClick={() => {
                                                this.setState({
                                                  idBookingFile: item._id,
                                                });
                                                this.downloadPickupReportByIdHandler();
                                              }}
                                            >
                                              <i className="fas fa-file-alt"></i> รายงาน pick up
                                              status
                                            </NavItemDropDownList>
                                          )}

                                          {item.document_driver && (
                                            <NavItemA>
                                              <a
                                                href={`${s3}/${item.document_driver}`}
                                                download={`ใบงาน-${item.name}`}
                                              >
                                                <i className="fal fa-file-download"></i>{' '}
                                                ดาวน์โหลดใบงาน
                                              </a>
                                            </NavItemA>
                                          )}

                                          {item.file && (
                                            <NavItemA>
                                              <a href={`${s3}/${item.file}`} download={item.name}>
                                                <i className="fal fa-file-archive"></i>{' '}
                                                ดาวน์โหลดไฟล์ต้นฉบับ
                                              </a>
                                            </NavItemA>
                                          )}

                                          <NavItemA>
                                            <a href={`/ka-queue/${item._id}`} target="_blank">
                                              <i className="fal fa-desktop"></i> Dashboard
                                            </a>
                                          </NavItemA>

                                          {admin == 'ann' ||
                                          admin == 'palmolive' ||
                                          item.status === 4 ? ( //รอเริ่มงาน
                                            <NavItemDropDownList
                                              onClick={() => {
                                                this.setState({
                                                  isOpenModalConfirmCancel: true,
                                                  fileNameBookingFile: item.name,
                                                  idBookingFile: item._id,
                                                });
                                              }}
                                            >
                                              <i className="fas fa-times"></i> ยกเลิก
                                            </NavItemDropDownList>
                                          ) : null}
                                        </NavDropdownContainer>
                                      </td>
                                      <td>{this.renderStatusMode(item.order_type)}</td>
                                      <td>{item.format_bookname ? item.format_bookname : null}</td>
                                      <td>{item.name}</td>
                                      <td
                                        className={`${classesLazada.textDanger} ${classesLazada.textBold}`}
                                      >
                                        <Moment format="DD/MM/YYYY HH:mm:ss">
                                          {item.pick_up_date}
                                        </Moment>
                                      </td>
                                      <td>{this.renderStatus(item.status)}</td>
                                      <td>
                                        {item.shipment_completed}/{item.total_shipment} Trip
                                      </td>
                                      <td>{this.formatMoney(item.total_accept_cod)}</td>
                                      {
                                        // <td>
                                        // {this.formatMoney(
                                        //   item.total_price_cod -
                                        //   item.total_cancel_cod -
                                        //   item.total_accept_cod
                                        //   )}
                                        //   </td>
                                        // <td>{this.formatMoney(item.total_price_cod)}</td>
                                      }
                                      <td>{this.formatMoney(item.total_cancel_cod)}</td>
                                      <td>
                                        {item.confirm_cod}/{item.confirm_cod_total}
                                      </td>
                                      {
                                        // <td
                                        //   className={`${classesLazada.textBold} ${classesLazada.textSuccess}`}
                                        // >
                                        //   {item.transfer_date ? (
                                        //     <Moment format="DD/MM/YYYY">{item.transfer_date}</Moment>
                                        //   ) : (
                                        //       '-'
                                        //     )}
                                        // </td>
                                      }
                                      <td>
                                        {item.create_date ? (
                                          <Moment format="DD/MM/YYYY">{item.create_date}</Moment>
                                        ) : (
                                          '-'
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </Table>
                          </div>
                          <div style={{ textAlign: 'right', marginTop: 20 }}>
                            {!loading && !error && (
                              <ReactPaginate
                                pageCount={data.lazadaImportOrderList.total_page}
                                forcePage={this.state.pageNumber - 1}
                                containerClassName="pagination"
                                nextLabel=">"
                                previousLabel="<"
                                onPageChange={({ selected }) => {
                                  this.setState({ pageNumber: selected + 1 });
                                }}
                              />
                            )}
                          </div>
                        </div>
                      }
                    />
                  );
                }}
              </Query>
            </div>
            <Modal
              show={this.state.showImportModal}
              onHide={() => this.setState({ showImportModal: false })}
            >
              <Modal.Header closeButton>
                <Modal.Title>อัพโหลด Tracking</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row style={{ marginBottom: '10px' }}>
                  <Col md={12}>Tracking file :</Col>
                </Row>
                <UploadFile
                  completed={file => {
                    this._inputImportFile1.current.value = null;
                    this.setState({ importFile: file });
                  }}
                >
                  {selectFile => {
                    return (
                      <React.Fragment>
                        <input
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          onChange={event => {
                            selectFile(event, `upload/jdProject/document_${new Date().getTime()}`);
                          }}
                          type="file"
                          id="file"
                          ref={this._inputImportFile1}
                          style={{ display: 'none' }}
                        />
                        <Button
                          style={{ marginRight: '15px' }}
                          onClick={() => this._inputImportFile1.current.click()}
                        >
                          <i className="fas fa-cloud-upload"></i> อัพโหลด Tracking
                        </Button>
                        <span>{this.state.importFile ? this.state.importFile.fileName : ''}</span>
                      </React.Fragment>
                    );
                  }}
                </UploadFile>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  disabled={this.state.importFile == null}
                  style={{
                    background: '#87CB16',
                    color: '#ffffff',
                    marginRight: '15px',
                  }}
                  onClick={() =>
                    this.uploadFileHandler(this.state.importFile, lazadaImportOrderListQuery)
                  }
                >
                  อัพโหลด Tracking
                </Button>
              </Modal.Footer>
            </Modal>

            <ModalConfirm
              show={this.state.isOpenModalConfirmCancel}
              onPressButtonConfirm={this.cancelShipmentLazada}
              styleColorButtonConfirm="primary"
              labelButtonConfirm={this.state.isLoading ? 'ยืนยัน...' : 'ยืนยัน'}
              labelButtonCancel={`ปิด`}
              onPressButtonCancel={() => this.setState({ isOpenModalConfirmCancel: false })}
              titleHeader={`คุณต้องการยกเลิกงานขนส่ง(Shipment) นี้ ใช่หรือไม่?`}
              onHide={() => this.setState({ isOpenModalConfirmCancel: false })}
              disabledButtonConfirm={this.state.isLoading}
            >
              <div style={{ lineHeight: 1 }}>
                File Name: <strong>{this.state.fileNameBookingFile}</strong>
              </div>
            </ModalConfirm>

            <ModalConfirm
              show={this.state.isOpenModalConfirmDownloadIdReport}
              onPressButtonConfirm={this.downloadReportByIdHandler}
              styleColorButtonConfirm="primary"
              labelButtonConfirm="ดาวน์โหลด"
              labelButtonCancel="ยกเลิก"
              onPressButtonCancel={() =>
                this.setState({ isOpenModalConfirmDownloadIdReport: false })
              }
              titleHeader={`Download Report ใช่หรือไม่?`}
              onHide={() => this.setState({ isOpenModalConfirmDownloadIdReport: false })}
            >
              <div style={{ lineHeight: 1 }}>
                File Name: <strong>{this.state.fileNameBookingFile}</strong>
              </div>
            </ModalConfirm>

            <ModalConfirm
              show={this.state.isOpenModalConfirmDownloadReport}
              onPressButtonConfirm={this.downloadReportHandler}
              styleColorButtonConfirm="primary"
              labelButtonConfirm={this.state.isLoading ? 'ดาวน์โหลด...' : 'ดาวน์โหลด'}
              labelButtonCancel={`ยกเลิก`}
              onPressButtonCancel={() => this.setState({ isOpenModalConfirmDownloadReport: false })}
              titleHeader={`Download Report ใช่หรือไม่?`}
              onHide={() => this.setState({ isOpenModalConfirmDownloadReport: false })}
              disabledButtonConfirm={this.state.isLoading}
            >
              <div style={{ lineHeight: 1 }}>
                <Row style={{ marginBottom: '10px' }}>
                  <Col md={12}> Mode</Col>
                </Row>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  defaultValue={null}
                  value={this.state.lazadaReportOption}
                  style={{ marginBottom: '10px' }}
                  onChange={event => {
                    this.setState({
                      lazadaReportOption: Number(event.target.value),
                    });
                  }}
                  name="lazadaReportOption"
                >
                  {/* จากการ์ดเทลโล่พี่ปาล์ม  */}
                  <option value={null}>ทั้งหมด</option>
                  <option value={1}>Last Mile (LM)</option>
                  <option value={2}>Return to Merchant (RM)</option>
                  <option value={9}>First Mile (FM)</option>
                  <option value={10}>Shuttle Haul (SH)</option>
                  <option value={11}>Reject Return (RR)</option>
                  <option value={12}>Direct Ship (DS)</option>
                  <option value={13}>Line Haul (LH)</option>
                  <option value={14}>BU First Mile (BUFM)</option>

                  {/* <option value={null}>ทั้งหมด</option>
                  <option value={1}>Last Mile (LM)</option>
                  <option value={2}>Return to Merchant (RM)</option>
                  <option value={3}>FIRST MILE (FM)</option>
                  <option value={4}>SPECIAL (SP)</option>
                  <option value={5}>Customer Return (CR)</option>
                  <option value={6}>Return to WH (RTWH)</option>
                  <option value={7}>Return to Customer (CR/RC)</option>
                  <option value={8}>Return to Merchant (CR/RM)</option>
                  <option value={9}>Line Haul (LH)</option> */}
                </FormControl>
                <Row style={{ marginBottom: '10px' }}>
                  <Col md={12}> ช่วงวันที่</Col>
                </Row>
                <FormGroup controlId="formValidationError1">
                  <DateRangePicker
                    onApply={(event, picker) => this.handleDateRangePickerReport(event, picker)}
                    onCancel={() => this.setState({ reportDate: '', show_reportDate: '' })}
                    containerStyles={{ display: 'block' }}
                    opens="right"
                    format="DD/MM/YYYY"
                  >
                    <FormControl
                      type="text"
                      value={this.state.show_reportDate}
                      placeholder="ค้นหาวันที่"
                      name="reportDate"
                    />
                  </DateRangePicker>
                </FormGroup>
              </div>
            </ModalConfirm>
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default compose(
  graphql(adminListQuery, { name: 'adminName' }),
  graphql(lazadaImportOrderUpdateMutation, {
    name: 'lazadaImportOrderUpdateMutation',
  }),
  graphql(updateTrackingBySummaryMutation, {
    name: 'updateTrackingBySummaryMutation',
  })
)(Shipments);
